export default __webpack_public_path__ + "static/media/Searchbanner2.96e373dd.jpg";